var map = {
	"./sig-bioinformatics.png": 834,
	"./sig-cloud.png": 162,
	"./sig-cog-comp.png": 400,
	"./sig-embedded.png": 450,
	"./sig-frontline.png": 581,
	"./sig-web-dev.png": 446,
	"./sig-xr.png": 806
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 502;